import { Box, LinearProgress as LinearProgressComponent } from '@mui/material';

const LinearProgress = ({ loading }: { loading?: boolean }) => {
  return <Box sx={{ height: 4 }}>{loading ? <LinearProgressComponent /> : null}</Box>;
};

export default LinearProgress;
